var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Locale "},_vm._l((_vm.locales),function(lang,i){return _c('BoxLang',{key:("Lang-" + i),attrs:{"value":lang.short,"id":i,"for":i,"lang":lang.short}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }